var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9c.213 0 .39-.072.535-.216a.725.725 0 0 0 .215-.534V7.5h.75c.213 0 .39-.072.534-.216A.724.724 0 0 0 12 6.75a.726.726 0 0 0-.216-.535A.725.725 0 0 0 11.25 6h-.75v-.75a.728.728 0 0 0-.215-.535.728.728 0 0 0-.535-.215.725.725 0 0 0-.534.215A.726.726 0 0 0 9 5.25V6h-.75a.725.725 0 0 0-.534.215.726.726 0 0 0-.216.535c0 .213.072.39.216.534a.724.724 0 0 0 .534.216H9v.75c0 .213.072.39.216.534A.724.724 0 0 0 9.75 9ZM1.5 12c-.413 0-.765-.147-1.059-.44A1.445 1.445 0 0 1 0 10.5v-9C0 1.087.147.735.441.441A1.443 1.443 0 0 1 1.5 0h3.881a1.484 1.484 0 0 1 1.05.431L7.5 1.5h6c.412 0 .766.147 1.06.441.293.294.44.646.44 1.059v7.5c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44h-12Zm0-10.5v9h12V3H6.881l-1.5-1.5H1.5Zm0 0v9-9Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseMatrix);
export default __webpack_public_path__ + "static/media/baseMatrix.57f9145418a023e1f4f54a9f7572e715.svg";
export { ForwardRef as ReactComponent };